import React from "react";
import Tile from "../../components/Tile/Tile";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { toggleResourceBookmark } from "../../stores/bookmarks/resourceBookmarksSlice";

export interface ResourceTileProps {
  resourceTiles: ContentfulTileProps[];
}

const TalkToAnExportResourceTiles = ({ resourceTiles }: ResourceTileProps) => {
  const dispatch = useAppDispatch();
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarks);

  const handleBookmarkTalkToAnExpert = (resourceTile: ContentfulTileProps) => {
    const { id, title, description } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.resourceId === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "TalkToAnExpertTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ userId, resourceId: id })
    );
  };

  return (
    <div className="resource-tiles-grid">
      {resourceTiles.map((tile) => (
        <div key={tile.id}>
          <Tile
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkTalkToAnExpert(tile);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default TalkToAnExportResourceTiles;
